import { useCallback, useMemo } from "react";
import { mapMenuToSidebarContent } from "../utils/menu-utils";
import { useAppDispatch } from "../redux/store/hooks/use-app.dispatch";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { fetchSidebar } from "../redux/store/slices/sidebar/sidebar-slice";

export const useSidebar = () => {
  const dispatch = useAppDispatch();
  const { items, isLoading, error } = useSelector(
    (state: RootState) => state.sidebar
  );

  const loadSidebar = useCallback(() => {
    dispatch(fetchSidebar());
  }, [dispatch]);

  const sidebarContent = useMemo(() => mapMenuToSidebarContent(items), [items]);

  return {
    menuItems: items,
    sidebarContent,
    isLoading,
    error,
    loadSidebar,
  };
};
